<template>
  <md-dialog :md-active.sync="show" class="assignment-dialog">
    <md-dialog-title>Add Assignment</md-dialog-title>
    <md-dialog-content>
      <form novalidate>
        <md-autocomplete id="member-search-box" :class="getAssignmentValidationClass('member')" v-model="memberSearchTerm" :md-options="members" @md-changed="searchMembers" @md-selected="selectMember">
          <label>Member</label>
          <template slot="md-autocomplete-item" slot-scope="{ item, term }">
            <div class="md-layout">
              <div class="md-layout-item md-size-25">
                <md-avatar class="md-large">
                  <img :src="item.avatar" alt="People">
                </md-avatar>
              </div>
              <div class="md-layout-item md-layout">
                <div class="md-layout-item md-size-100">
                  <md-highlight-text :md-term="term">{{ item | name }}</md-highlight-text>
                </div>
                <div class="md-layout-item">
                  {{ item.email }}
                </div>
              </div>
            </div>

          </template>

          <template slot="md-autocomplete-empty" slot-scope="{ term }">
            No members matching "{{ term }}" were found.
          </template>
          <span class="md-error" v-if="!$v.addMember.member.required">A member is required</span>
        </md-autocomplete>
        <div class="md-layout">
          <div class="md-layout-item md-size-100">
            <label :class="getAssignmentValidationClass('delivery_method')" for="delivery_method">Delivery Method</label>
          </div>
          <div class="md-layout-item md-size-100">
            <md-radio v-model="addMember.delivery_method" value="sms">SMS</md-radio>
            <md-radio v-model="addMember.delivery_method" value="email">Email</md-radio>
            <md-radio v-model="addMember.delivery_method" value="slack">Slack</md-radio>
            <span class="md-error" v-if="!$v.addMember.delivery_method.required">The delivery method is required</span>
          </div>
        </div>
        <md-datepicker v-model="addMember.start_date" :class="getAssignmentValidationClass('start_date')" md-immediately>
          <label>Start Date</label>
        </md-datepicker>
        <span class="md-error" v-if="!$v.addMember.start_date">The start date is required</span>
      </form>
    </md-dialog-content>
    <md-dialog-actions>
      <md-button class="md-primary" @click="cancel()">Cancel</md-button>
      <md-button class="md-primary" @click="validateMember()">Save</md-button>
    </md-dialog-actions>
  </md-dialog>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { mapState, mapActions } from 'vuex'
import {
  required,
  integer,
  url
} from 'vuelidate/lib/validators'
export default {
  name: "AssignmentDialog",
  mixins: [validationMixin],
  props: {
    show: Boolean
  },
  methods: {
    ...mapActions({
      searchMembers: 'searchMembers'
    }),
    selectMember(c) {
      this.addMember.member = c
      this.memberSearchTerm = c.first_name + " " + c.last_name
    },
    getAssignmentValidationClass (fieldName) {
      const field = this.$v.addMember[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    clearMemberForm () {
      this.$v.$reset()
      this.addMember.member= {}
      this.addMember.start_date = ''
      this.addMember.delivery_method = 'email'
    },
    validateMember: function() {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        let m = {
          member_id: this.addMember.member.user_id,
          first_name: this.addMember.member.first_name,
          last_name: this.addMember.member.last_name,
          avatar: this.addMember.member.avatar,
          assignment_date: this.addMember.start_date,
          delivery_method: this.addMember.delivery_method
        }
        this.$emit("save",{ ...m }) 
        this.clearMemberForm()
      }
    },
    cancel: function() {
      this.clearMemberForm()
      this.$emit("cancel")
    }
  },
  data: function() {
    return {
      memberSearchTerm: '',
      addMember: {
        member: {},
        start_date: '',
        delivery_method: 'email'
      }
    }
  },
  computed: {
    ...mapState({
      members: s => s.admin.members
    })
  },
  validations: {
    addMember: {
      member: {
        required
      },
      start_date: {
        required
      },
      delivery_method: {
        required
      }
    }
  },
  filters: {
    name: function(member){
      return member.first_name + ' ' + member.last_name
    }
  }}
</script>
<style lang="scss">
.assignment-dialog {
  min-width: 400px;
}
.md-menu-content{
  z-index: 999 !important;
}
.md-checkbox{
  display: flex;
}
</style>
